module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-head"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Foreword"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter_01"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1.")])]), _vm._v(" Casa Buonaparte")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_02"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2.")])]), _vm._v(" Bust of Madame Mère")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_03"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3.")])]), _vm._v(" Statue of Paoli")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_04"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4.")])]), _vm._v(" Statue of a Young Napoleon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter_05"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5.")])]), _vm._v(" Mètre étalon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter_06"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6.")])]), _vm._v(" Snuff Box")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7.")])]), _vm._v(" Facial Reconstruction of Maximilien Robespierre")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8.")])]), _vm._v(" French Gribeauval Cannon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("9.")])]), _vm._v(" Photograph of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montebello")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10.")])]), _vm._v(" Bust of Napoleon from the Italian Campaign")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11.")])]), _vm._v(" The Four Bronze Horses")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12.")])]), _vm._v(" Plaque to Napoleon and Josephine")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("13.")])]), _vm._v(" Mameluke Saddle and Adornments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("14.")])]), _vm._v(" Description de L’ Égypte by Fourier")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15.")])]), _vm._v(" Napoleon’s Sabre")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("16.")])]), _vm._v(" Napoleon’s Chess Set")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("17.")])]), _vm._v(" Proclamation Announcing the Coup of 18 Brumaire")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("18.")])]), _vm._v(" Napoleon’s Uniform Coat")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("19.")])]), _vm._v(" Body of Le Vizir")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("20.")])]), _vm._v(" Josephine’s Jewellery Box")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("21.")])]), _vm._v(" Napoleon’s Dress Coat as First Consul")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("22.")])]), _vm._v(" Papal Tiara")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("23.")])]), _vm._v(" French Print of the Treaty of Mortefontaine")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("24.")])]), _vm._v(" Print of the Assassination Attempt on Napoleon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("25.")])]), _vm._v(" Miniature Portrait of Lucien Bonaparte")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26.")])]), _vm._v(" French Plan of Port Jackson in Australia, 1802")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("27.")])]), _vm._v(" The Luxembourg Palace")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("28.")])]), _vm._v(" Rosetta Stone")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("29.")])]), _vm._v(" Pauline’s Diplomatic Bag")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("30.")])]), _vm._v(" Legion of Honour")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("31.")])]), _vm._v(" Slave Manacles")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("32.")])]), _vm._v(" The Lycée in Autun")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("33.")])]), _vm._v(" Bust of Toussaint Louverture")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("34.")])]), _vm._v(" Gold ‘Napoleon’ from Year 12 (1803)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("35.")])]), _vm._v(" Statue of Napoleon as a Roman Emperor")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("36.")])]), _vm._v(" Brass Commemorative Medal for the Peace of Amiens")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("37.")])]), _vm._v(" The Preface of the Louisiana Purchase")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("38.")])]), _vm._v(" Extract from the Records of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Détenus")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("39.")])]), _vm._v(" Pillbox with an Image of Elisa Bonaparte")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter_40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("40.")])]), _vm._v(" Memorial to the Duke of Enghien at Vincennes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("41.")])]), _vm._v(" Napoleon Portrayed as a Roman Administrator")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("42.")])]), _vm._v(" Column at Boulogne-sur-Mer")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter_43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("43.")])]), _vm._v(" Gold Leaf")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("44.")])]), _vm._v(" Carpet Decorated with Napoleonic Bees")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("45.")])]), _vm._v(" Battle-Damaged Eagle, 1804")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter_46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("46.")])]), _vm._v(" Cover of Beethoven’s Symphony No.3")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Chapter_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("47.")])]), _vm._v(" Bearskin of a Grenadier of the Imperial Guard")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Chapter_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("48.")])]), _vm._v(" Napoleon’s Bath at St. Helena")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Chapter_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("49.")])]), _vm._v(" Memorial to the Battle of Austerlitz")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55_Chapter_50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("50.")])]), _vm._v(" An ‘Empire Style’ Table")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56_Chapter_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("51.")])]), _vm._v(" Model of the Column in the Place Vendôme")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57_Chapter_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("52.")])]), _vm._v(" Westphalian "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "images",
      "src": "images/ipg_v_1.jpg"
    }
  }), _vm._v(" Thaler Coin")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58_Chapter_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("53.")])]), _vm._v(" Miniature Portrait of the Duke of Brunswick")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59_Chapter_54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("54.")])]), _vm._v(" The Great Basin at Antwerp")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60_Chapter_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("55.")])]), _vm._v(" The Treaty of the Confederation of the Rhine")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61_Chapter_56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("56.")])]), _vm._v(" Commemorative Medallion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62_Chapter_57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("57.")])]), _vm._v(" Print of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Douanier")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/63_Chapter_58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("58.")])]), _vm._v(" Large Sèvre Plate")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64_Chapter_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("59.")])]), _vm._v(" French Cuirass Showing a Bullet Strike")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/65_Chapter_60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("60.")])]), _vm._v(" Caroline Bonaparte’s Necklace")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/66_Chapter_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("61.")])]), _vm._v(" Miniature of Napoleon and Alexander Embracing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/67_Chapter_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("62.")])]), _vm._v(" Czapka Helmet of the Polish Lancers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/68_Chapter_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("63.")])]), _vm._v(" Josephine’s Tiara")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/69_Chapter_64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("64.")])]), _vm._v(" Model of His Danish Majesty’s Ship, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Phoenix")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/70_Chapter_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("65.")])]), _vm._v(" Photograph of Alexandre Colonna-Walewski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/71_Chapter_66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("66.")])]), _vm._v(" Tomb of Pope Pius VII")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/72_Chapter_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("67.")])]), _vm._v(" Document signed by General Delaborde, Lisbon 1808")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/73_Chapter_68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("68.")])]), _vm._v(" Contemporary Image of Soldiers of the Kingdom of Holland")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74_Chapter_69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("69.")])]), _vm._v(" Napoleon’s Throne")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75_Chapter_70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("70.")])]), _vm._v(" Infantryman’s Shako from the Kingdom of Naples")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/76_Chapter_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("71.")])]), _vm._v(" Spanish Coins")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/77_Chapter_72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("72.")])]), _vm._v(" Sugar Beets")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/78_Chapter_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("73.")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Le Moniteur")]), _vm._v(" Newspaper dated Tuesday 10 November 1807")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79_Chapter_74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("74.")])]), _vm._v(" Austrian 7-pounder Cannon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/80_Chapter_75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("75.")])]), _vm._v(" Maria Walewska’s Dress")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/81_Chapter_76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("76.")])]), _vm._v(" Napoleon’s Satchel")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/82_Chapter_77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("77.")])]), _vm._v(" Statue of Andreas Hofer in Bergisel")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/83_Chapter_78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("78.")])]), _vm._v(" Marie Louise’s Pocket Watch")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/84_Chapter_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("79.")])]), _vm._v(" French Prisoner of War Articles")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/85_Chapter_80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("80.")])]), _vm._v(" The Cradle of the King of Rome")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/86_Chapter_81",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("81.")])]), _vm._v(" Russian Grenadier’s Mitre Hat with Two Bullet Holes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/87_Chapter_82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("82.")])]), _vm._v(" Napoleon’s Sledge")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/88_Chapter_83",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("83.")])]), _vm._v(" Napoleon’s Hat from the Russian Campaign")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/89_Chapter_84",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("84.")])]), _vm._v(" Arc de Triomphe")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/90_Chapter_85",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("85.")])]), _vm._v(" Contemporary Print of General Claude de Malet")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/91_Chapter_86",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("86.")])]), _vm._v(" Josephine’s Dress")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/92_Chapter_87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("87.")])]), _vm._v(" Napoleon Crossing the Alps")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/93_Chapter_88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("88.")])]), _vm._v(" An order from Fouché, Head of Police, 18 Brumaire Year 8")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/94_Chapter_89",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("89.")])]), _vm._v(" Napoleon’s Travelling Nécessaire")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/95_Chapter_90",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("90.")])]), _vm._v(" Monument to the Battle of the Nations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/96_Chapter_91",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("91.")])]), _vm._v(" Announcement of Napoleon’s Abdication")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/97_Chapter_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("92.")])]), _vm._v(" French Infantryman’s Shako")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/98_Chapter_93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("93.")])]), _vm._v(" Line Drawing of Conscripts for Napoleon’s Army")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/99_Chapter_94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("94.")])]), _vm._v(" Flag of Elba")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/100_Chapter_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("95.")])]), _vm._v(" Coach from Waterloo")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/101_Chapter_96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("96.")])]), _vm._v(" Robert Fulton’s ‘Nautilus’ Submarine")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/102_Chapter_97",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("97.")])]), _vm._v(" Napoleon’s Letter to the Prince Regent")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/103_Chapter_98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("98.")])]), _vm._v(" Napoleon’s Straw Hat")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/104_Chapter_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("99.")])]), _vm._v(" Napoleon’s Death Mask")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/105_Chapter_100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap_float2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("100.")])]), _vm._v(" Napoleon in his Tomb")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0